import * as React from "react";

const ArrowCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="99px" height="99pxml:spacex" viewBox="0 0 99 99" enable-background="new 0 0 99 99">
            <g id="change2">
                <circle fill="#FFFFFF" cx="49.5" cy="49.5" r="48"/>
            </g>
            <g id="change3_1_">
                <path fill="#D9D9D8" d="M49.5,99C22.205,99,0,76.793,0,49.5C0,22.205,22.205,0,49.5,0C76.793,0,99,22.205,99,49.5   C99,76.793,76.793,99,49.5,99z M49.5,3C23.859,3,3,23.859,3,49.5C3,75.141,23.859,96,49.5,96C75.141,96,96,75.141,96,49.5   C96,23.859,75.141,3,49.5,3z"/>
            </g>
            <g id="change1">
                <polygon fill="#2E2E2E" points="45.524,68.221 63.809,49.236 45.489,30.779 41.227,35.01 55.418,49.303 41.195,64.061  "/>
            </g>
        </svg>
    );
};

export default React.memo(ArrowCircle);